module.exports = __webpack_public_path__ + "static/media/undraw_asset_selection_re_k5fj.6455c599.png";